import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/hero.css";

const propertySearchUrl = "/properties";
const defaultBackgroundImage =
  "https://api.gestorimobiliario360.com.br/api/media/b76ccaf4581b4ba462929b10fffd0d8879131fbfb05d4034ba6e7ff7f2aefdcb";

const defaultQuickLinks = [
  {
    title: "Casas Esteio",
    url: `${propertySearchUrl}?city=esteio&type=2&sort=price-asc`,
  },
  {
    title: "Apartamentos Esteio",
    url: `${propertySearchUrl}?city=esteio&type=1&sort=price-asc`,
  },
  {
    title: "Casas Sapucaia",
    url: `${propertySearchUrl}?city=sapucaia+do+sul&type=2&sort=price-asc`,
  },
  {
    title: "Apartamentos Sapucaia",
    url: `${propertySearchUrl}?city=sapucaia+do+sul&type=1&sort=price-asc`,
  },
];

const HeroSelect = ({ id, label, placeholder, options, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedOption = options.find((option) => option.value === value);

  const handleBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsOpen(false);
    }
  };

  return (
    <div
      className="hero-field hero-select-field"
      onBlur={handleBlur}
      onKeyDown={(event) => event.key === "Escape" && setIsOpen(false)}
    >
      <button
        className="hero-select-trigger"
        type="button"
        aria-label={label}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        aria-controls={`${id}-options`}
        onClick={() => setIsOpen((open) => !open)}
      >
        <span>{selectedOption?.label || placeholder}</span>
        <span className="hero-chevron" aria-hidden="true" />
      </button>
      {isOpen && (
        <div
          className="hero-options"
          id={`${id}-options`}
          role="listbox"
          aria-label={label}
        >
          {options.map((option) => (
            <button
              className="hero-option"
              key={option.value}
              type="button"
              role="option"
              aria-selected={value === option.value}
              onClick={() => {
                onChange(option.value);
                setIsOpen(false);
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const Hero = ({
  title = "Ofertas incríveis em Esteio e Sapucaia",
  supportingText = "Solicite um tour de visitas e escolha seu imóvel novo",
  quickLinks = defaultQuickLinks,
  backgroundImages = [defaultBackgroundImage],
}) => {
  const [city, setCity] = useState("");
  const [type, setType] = useState("");
  const [backgroundImage] = useState(() => {
    if (!backgroundImages.length) return "";
    return backgroundImages[Math.floor(Math.random() * backgroundImages.length)];
  });
  const navigate = useNavigate();

  const handleSearch = (event) => {
    event.preventDefault();
    const searchParams = new URLSearchParams();
    new FormData(event.currentTarget).forEach((value, key) => {
      if (value) searchParams.set(key, value);
    });
    navigate(`${propertySearchUrl}?${searchParams.toString()}`);
  };

  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero-image" aria-hidden="true">
        {backgroundImage && <img src={backgroundImage} alt="" />}
      </div>
      <div className="hero-content">
        <h1 className="hero-title" id="hero-title">
          {title}
        </h1>
        {supportingText && <p className="hero-lead">{supportingText}</p>}

        <form
          className="hero-search"
          action={propertySearchUrl}
          method="get"
          onSubmit={handleSearch}
          aria-label="Buscar imóveis"
        >
          <HeroSelect
            id="hero-city"
            label="Cidade"
            placeholder="Cidade"
            value={city}
            onChange={setCity}
            options={[
              { value: "esteio", label: "Esteio" },
              { value: "sapucaia do sul", label: "Sapucaia do Sul" },
            ]}
          />
          <HeroSelect
            id="hero-type"
            label="Tipo"
            placeholder="Tipo"
            value={type}
            onChange={setType}
            options={[
              { value: "2", label: "Casa" },
              { value: "1", label: "Apartamento" },
            ]}
          />
          <label className="hero-field hero-keyword-field">
            <span className="visually-hidden">Código, cidade ou bairro</span>
            <input
              type="search"
              name="search"
              placeholder="Código, Cidade, Bairro"
            />
          </label>
          <input type="hidden" name="city" value={city} />
          <input type="hidden" name="type" value={type} />
          <input type="hidden" name="sort" value="price-asc" />
          <button className="hero-search-button" type="submit">
            Buscar
          </button>
        </form>

        <nav className="hero-links" aria-label="Buscas populares">
          {quickLinks.map((link, index) => (
            <a
              className="hero-link"
              href={link.url}
              key={`${link.title}-${index}`}
            >
              {link.title}
            </a>
          ))}
        </nav>
      </div>
    </section>
  );
};

export default Hero;
